module.exports = __webpack_public_path__ + "static/media/4_AP_ES_Z1.1aaa7fe6.png";